import { agreementsTableFieldsFragment } from "@lyfegen-platform/graphql-schema/fragments";
import gql from "graphql-tag";

export interface AgreementVars {
	first: number;
	offset: number;
	orderBy: string;
	filter: any;
}

export const GET_AGREEMENTS = gql`
	${agreementsTableFieldsFragment}

	query GetAgreements($where: AgreementTableRowWhere!, $options: AgreementTableRowOptions) {
		agreementTableRows(where: $where, options: $options) {
			...GetAgreementsFields
		}

		allAgreementCount: agreementTableRows {
			_count
		}

		filteredAgreementCount: agreementTableRows(where: $where) {
			_count
		}

		CurrentOrganization {
			id
			name
		}
	}
`;

export const GET_REPORTING_DASHBOARD_AGREEMENTS = gql`
	query GetReportingDashboardAgreements($organizationId: ID) {
		baseAgreements(where: { isDeleted: false, isHidden: false, isFirstVersion: true, status: RUNNING }) {
			id
			counterpartiesConnection(where: { node: { id: $organizationId } }) {
				edges {
					role
					node {
						id
					}
				}
			}
		}
	}
`;

export const GET_FILTERED_AGREEMENT_COUNT = gql`
	query GetFilteredAgreementCount($where: AgreementTableRowWhere!) {
		filteredAgreementCount: agreementTableRows(where: $where) {
			_count
		}
	}
`;

export const GET_AGREEMENTS_FILTERS = gql`
	query GetAgreementsFilters {
		GetAgreementsTableSourceFilterData {
			tags
			counterparties
			names
			diseases {
				name
				indications
			}
			brandNames
			statuses
			minValidFromDate
			maxValidFromDate
			amountRanges {
				start
				end
				count
			}
			daysToExpiryRanges {
				start
				end
				count
			}
			ids
		}
		filters: GetUserContextFiltersAgreements
	}
`;

export const GET_PUBLIC_AGREEMENTS_FILTERS = gql`
	query GetPublicAgreementsFilters {
		GetPublicAgreementsSourceFilterData {
			products
			manufacturers
			payers
			models
			diseases
			therapeuticAreas
			productTypes
			measures
			countries
			regions
			years
			statuses
			mechanismsOfAction
			uncertainties
			hta
			hasRenegotiations
		}
		filters: GetUserFiltersPublicAgreements
	}
`;

export const GET_PUBLIC_AGREEMENTS_FILTERS_STATE = gql`
	query GetPublicAgreementsFiltersState {
		filters: GetUserFiltersPublicAgreements
	}
`;

export const UPDATE_AGREEMENTS_FILTER = gql`
	mutation UpdateUserContextFiltersAgreements($req: String) {
		UpdateUserContextFiltersAgreements(req: $req)
	}
`;

export const AGREEMENTS_SUBSCRIPTION = gql`
	subscription OnAgreementCreated {
		agreementCreated
	}
`;
